(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emma-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emma-video-carousel')) {
    customElements.define('emma-video-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-video-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
        if (!this.viewport || !this.cards.length) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.previous = this.querySelector('[data-video-previous]');
        this.next = this.querySelector('[data-video-next]');
        this.dots = Array.from(this.querySelectorAll('[data-video-dot]'));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previewsPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.states = new Map();

        this.cards.forEach(card => {
          const video = card.querySelector('video');
          if (!video) return;
          const state = {
            video, button: card.querySelector('[data-video-play]'), sound: card.querySelector('[data-video-sound]'),
            error: card.querySelector('[data-video-error]'), visible: false, failed: false,
            userPaused: card.dataset.userPaused === 'true', userStarted: false, pending: false, requestId: 0
          };
          this.states.set(card, state);
          video.controls = false;
          video.muted = true;
          state.button.hidden = false;
          state.sound.hidden = false;
          state.button.addEventListener('click', () => this.togglePlayback(card), { signal });
          state.sound.addEventListener('click', () => this.toggleSound(card), { signal });
          video.addEventListener('play', () => this.updateCard(card), { signal });
          video.addEventListener('pause', () => this.updateCard(card), { signal });
          video.addEventListener('volumechange', () => this.updateCard(card), { signal });
          video.addEventListener('ended', () => this.pauseCard(card, true), { signal });
          video.addEventListener('error', () => {
            state.failed = true;
            state.error.hidden = false;
            this.pauseCard(card);
          }, { signal });
          this.updateCard(card);
        });

        this.previous.addEventListener('click', () => this.goTo(this.currentIndex() - 1), { signal });
        this.next.addEventListener('click', () => this.goTo(this.currentIndex() + 1), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), { signal }));
        this.viewport.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          const moves = { ArrowLeft: -1, ArrowRight: 1 };
          if (event.key in moves) { event.preventDefault(); this.goTo(this.currentIndex() + moves[event.key]); }
        }, { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.previewsPaused = true; this.refreshPreviews(); }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.states.forEach(state => { state.video.muted = true; });
          this.refreshPreviews();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.indexOf(event.target.closest('[data-video-card]'));
          if (index >= 0) this.goTo(index);
        }, { signal });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const state = this.states.get(entry.target);
              if (!state) return;
              state.visible = entry.isIntersecting && entry.intersectionRatio >= .5;
              if (entry.isIntersecting) state.video.preload = 'metadata';
              if (!state.visible) state.video.muted = true;
            });
            this.refreshPreviews();
          }, { threshold: [0, .5] });
          this.states.forEach((state, card) => this.observer.observe(card));
        } else {
          this.previewsPaused = true;
          this.states.forEach(state => { state.visible = true; state.video.preload = 'metadata'; });
        }
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.viewport);
        this.updateNavigation();
        this.refreshPreviews();
      }

      targetPosition(index) {
        const card = this.cards[index];
        const centered = getComputedStyle(card).scrollSnapAlign === 'center';
        const left = centered ? card.offsetLeft + card.offsetWidth / 2 - this.viewport.clientWidth / 2 : card.offsetLeft - this.cards[0].offsetLeft;
        return Math.max(0, Math.min(this.viewport.scrollWidth - this.viewport.clientWidth, left));
      }

      currentIndex() {
        let closest = 0;
        this.cards.forEach((card, index) => {
          if (Math.abs(this.targetPosition(index) - this.viewport.scrollLeft) < Math.abs(this.targetPosition(closest) - this.viewport.scrollLeft)) closest = index;
        });
        return closest;
      }

      goTo(index) {
        index = Math.max(0, Math.min(this.cards.length - 1, index));
        this.viewport.scrollTo({ left: this.targetPosition(index), behavior: this.motion.matches ? 'instant' : 'smooth' });
      }

      updateNavigation() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const index = this.currentIndex();
        this.previous.hidden = this.next.hidden = max <= 2;
        this.previous.disabled = this.viewport.scrollLeft <= 2;
        this.next.disabled = this.viewport.scrollLeft >= max - 2;
        this.querySelector('[data-video-dots]').hidden = max <= 2;
        this.querySelector('.emma-videos__footer').hidden = max <= 2;
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }

      updateCard(card) {
        const state = this.states.get(card);
        const playing = !state.video.paused || state.pending;
        state.button.dataset.paused = String(!playing);
        state.button.setAttribute('aria-label', (playing ? 'Metti in pausa: ' : 'Riproduci: ') + card.dataset.label);
        state.sound.setAttribute('aria-pressed', String(!state.video.muted));
        state.sound.setAttribute('aria-label', (state.video.muted ? 'Attiva audio: ' : 'Disattiva audio: ') + card.dataset.label);
      }

      pauseCard(card, remember = false) {
        const state = this.states.get(card);
        if (remember) {
          state.userPaused = true;
          card.dataset.userPaused = 'true';
        }
        state.requestId++;
        state.pending = false;
        state.video.pause();
        this.updateCard(card);
      }

      playCard(card, userStarted = false) {
        const state = this.states.get(card);
        if (userStarted) {
          state.userPaused = false;
          card.dataset.userPaused = 'false';
          state.userStarted = true;
          state.failed = false;
          state.error.hidden = true;
          if (state.video.error) state.video.load();
          if (state.video.ended) state.video.currentTime = 0;
        }
        if (state.pending || !state.video.paused) return;
        const controller = this.controller;
        const requestId = ++state.requestId;
        state.video.loop = state.video.muted;
        state.pending = true;
        // Called directly by the tap handler, so mobile browsers can enable sound.
        state.video.play().then(() => {
          if (this.controller !== controller || state.requestId !== requestId) return;
          state.pending = false;
          this.updateCard(card);
        }).catch(error => {
          if (this.controller !== controller || state.requestId !== requestId) return;
          state.pending = false;
          if (userStarted && error.name !== 'AbortError') {
            state.failed = true;
            state.error.hidden = false;
          }
          this.updateCard(card);
        });
        this.updateCard(card);
      }

      togglePlayback(card) {
        const state = this.states.get(card);
        if (!state.video.paused || state.pending) {
          this.pauseCard(card, true);
        } else {
          this.playCard(card, true);
          this.goTo(this.cards.indexOf(card));
        }
      }

      toggleSound(card) {
        const state = this.states.get(card);
        const enableSound = state.video.muted;
        this.states.forEach((other, otherCard) => {
          if (otherCard === card) return;
          other.video.muted = true;
          other.video.loop = true;
          this.updateCard(otherCard);
        });
        state.video.muted = !enableSound;
        state.video.loop = !enableSound;
        if (enableSound) {
          this.playCard(card, true);
          this.goTo(this.cards.indexOf(card));
        }
        this.updateCard(card);
      }

      refreshPreviews() {
        const automatic = this.dataset.autoplay === 'true' && !this.previewsPaused;
        this.states.forEach((state, card) => {
          if (!document.hidden && state.visible && !state.failed && !state.userPaused && (automatic || state.userStarted)) {
            this.playCard(card);
          } else {
            this.pauseCard(card);
          }
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.states?.forEach(state => state.video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vm-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-marquee')) {
    customElements.define('vm-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.vm-marquee__track');
        this.group = this.track?.firstElementChild;
        if (!this.group) return;
        this.resizeObserver = new ResizeObserver(() => this.fill());
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.group);
        this.fill();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      fill() {
        const width = this.group.getBoundingClientRect().width;
        if (!width || !this.clientWidth) return;
        // One whole group moves offscreen; the remaining copies must cover the banner.
        const count = Math.max(2, Math.ceil(this.clientWidth / width) + 1);
        while (this.track.children.length < count) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(item => {
            item.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(copy);
        }
        while (this.track.children.length > count) this.track.lastElementChild.remove();
        this.style.setProperty('--vm-marquee-shift', `${-width}px`);
        this.style.setProperty('--vm-marquee-duration', `${width / 36}s`);
        this.setAttribute('data-ready', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
